/**
 * Hierarchy selection ids for scene editor.
 * Real components use their gameConfig id. Setting groups (from predefined
 * `groups`) use a suffix so they can be selected without colliding.
 */

export const SCENE_EDITOR_GROUP_MARK = "::g:";
export const SCENE_EDITOR_SUBGROUP_MARK = "::sg:";

export function makeSceneEditorGroupItemId(componentId, groupCaption) {
  return `${componentId}${SCENE_EDITOR_GROUP_MARK}${groupCaption}`;
}

export function makeSceneEditorSubGroupItemId(componentId, groupCaption, subGroupCaption) {
  return `${componentId}${SCENE_EDITOR_GROUP_MARK}${groupCaption}${SCENE_EDITOR_SUBGROUP_MARK}${subGroupCaption}`;
}

/**
 * @param {string | null | undefined} itemId
 * @returns {{
 *   type: "component" | "group" | "subgroup",
 *   componentId: string,
 *   groupCaption?: string,
 *   subGroupCaption?: string,
 * } | null}
 */
export function parseSceneEditorHierarchySelection(itemId) {
  if (!itemId || String(itemId).startsWith("cat-")) return null;
  const s = String(itemId);
  const gIdx = s.indexOf(SCENE_EDITOR_GROUP_MARK);
  if (gIdx === -1) {
    return { type: "component", componentId: s };
  }
  const componentId = s.slice(0, gIdx);
  const rest = s.slice(gIdx + SCENE_EDITOR_GROUP_MARK.length);
  const sgIdx = rest.indexOf(SCENE_EDITOR_SUBGROUP_MARK);
  if (sgIdx === -1) {
    return { type: "group", componentId, groupCaption: rest };
  }
  return {
    type: "subgroup",
    componentId,
    groupCaption: rest.slice(0, sgIdx),
    subGroupCaption: rest.slice(sgIdx + SCENE_EDITOR_SUBGROUP_MARK.length),
  };
}
